import { action, observable } from 'mobx';
import { ProjectsStore } from './ProjectsStore';
import { appConfig } from 'cd-eft/config/AppConfig';

class ThreeCrossSectionStoreProjectsStore extends ProjectsStore {
    constructor(private threecrosssectiondesignstore: any) {
        super(threecrosssectiondesignstore);
    }
}

interface IThreeCrossSectionObject {
    designElementId: number;
    surveyCoordinateSystem: number;
    mainReachStation: number;
    waterwayReachStations: IWaterwayReachStation[];
    threeCrossSectionPoints: IThreeCrossSectionPoint[];
}

export interface IWaterwayReachStation {
    index: number;
    stationName: string,
    station: number,
}

export interface IThreeCrossSectionPoint {
    distance: number;
    originalElevation: number;
    designElevation: number;
    cutFillHeight: number;
}

export class ThreeCrossSectionDesignStore {
    constructor(private appStore: any) {
        this.projectsStore = new ThreeCrossSectionStoreProjectsStore(this);
        this.init();
    }

    @observable projectsStore: ThreeCrossSectionStoreProjectsStore;
    @observable threeCrossSectionObject!: IThreeCrossSectionObject;
    @observable threeCrossSectionPoint!: IThreeCrossSectionPoint;
    @observable selectedWaterwayReachStations: any[] = [];

    // Loading and Errors -->
    @observable isLoading: boolean = false;
    @observable error: boolean = false;
    @observable errorMsg: string = '';
    @action.bound setError(msg: string) {
        if (msg !== '') {
            this.error = true;
            this.errorMsg = msg;
            this.isLoading = false;
        } else {
            this.error = false;
            this.errorMsg = '';
            this.isLoading = false;
        }
    }
    // <-- Loading and Errors

    @action reset() {
        this.init();
    }

    @action resetCurrentObject() {
        this.threeCrossSectionObject = { ...this.initialThreeCrossSectionObject };
        this.selectedWaterwayReachStations = [];
    }

    @action init() {
        this.resetCurrentObject();
        this.setError('');
        this.isLoading = false;
    }

    initialWaterwayReachStation: IWaterwayReachStation = {
        index: 0,
        stationName: '',
        station: 0.0,
    };

    initialThreeCrossSectionPoint: IThreeCrossSectionPoint = {
        distance: 0.0,
        originalElevation: 0.0,
        designElevation: 0.0,
        cutFillHeight: 0.0,
    };

    initialThreeCrossSectionObject: IThreeCrossSectionObject = {
        designElementId: 0,
        surveyCoordinateSystem: appConfig.tempHardCodes.wkid,
        mainReachStation: -1,
        waterwayReachStations: [],
        threeCrossSectionPoints: [],
    };
}
